import { commonGuard, adminGuard } from "../func"

const paymentRouter = {
  path: "payment",
  component: () => import("@/components/frame/main.vue"),
  children: [
    {
      path: "",
      name: "payment",
      beforeEnter: commonGuard,
      redirect: { name: "license" },
      component: () => import("@/components/payment/index.vue"),
      children: [
        {
          path: "license",
          name: "license",
          component: () => import("@/components/payment/license/index.vue"),
          beforeEnter: adminGuard,
        },
        {
          path: "history",
          name: "payment-history",
          component: () => import("@/components/payment/history/index.vue"),
          beforeEnter: adminGuard,
        },
      ],
    },
  ],
}

export default paymentRouter
